export default "__VITE_ASSET__P4bnv6iV__"